/**
 * AdminApprovalsTable.js
 *
 * Admin device approvals list table (workflow list UX — matches transfer pages).
 */

import React from 'react';
import ApprovalStatusBadge from './ApprovalStatusBadge';
import { DeviceIDBadge } from '../../../../shared/components/common/Badges';
import SortableTh from '../../../../shared/components/common/SortableTh';

const formatDate = (value) => {
  if (!value) return '-';
  return new Date(value).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

const AdminApprovalsTable = ({
  data = [],
  onViewDevice = null,
  loading = false,
  departments = [],
  sorting = null,
  onSortChange = null,
}) => {
  const getDepartmentIcon = (departmentName) => {
    if (!departmentName || !departments?.length) {
      return '🏢';
    }
    const dept = departments.find(
      (d) => d.name?.toLowerCase() === departmentName?.toLowerCase()
    );
    return dept?.icon || '🏢';
  };

  if (loading && data.length === 0) {
    return <p>Loading approvals...</p>;
  }

  return (
    <table className="transfers-table admin-approvals-table">
      <thead>
        <tr>
          <SortableTh column="device_name" sorting={sorting} onSortChange={onSortChange}>
            Device
          </SortableTh>
          <SortableTh column="department" sorting={sorting} onSortChange={onSortChange}>
            Department
          </SortableTh>
          <SortableTh column="manager_name" sorting={sorting} onSortChange={onSortChange}>
            Manager
          </SortableTh>
          <SortableTh column="approval_status" sorting={sorting} onSortChange={onSortChange}>
            Status
          </SortableTh>
          <SortableTh column="requested_at" sorting={sorting} onSortChange={onSortChange}>
            Requested date
          </SortableTh>
          <SortableTh
            column="resubmission_count"
            sorting={sorting}
            onSortChange={onSortChange}
            className="center"
          >
            Resubmissions
          </SortableTh>
          <th className="admin-approvals-action-col">Action</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row) => {
          const dept =
            row.device_data?.department || row.department || 'N/A';
          const isPending = row.approval_status === 'pending';
          return (
            <tr key={row.approval_id}>
              <td>
                <div className="transfer-device-cell">
                  <span className="transfer-device-name">{row.device_name || 'N/A'}</span>
                  <DeviceIDBadge deviceId={row.device_identifier || 'N/A'} size="small" />
                </div>
              </td>
              <td>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                  <span className="department-icon-small">{getDepartmentIcon(dept)}</span>
                  <span className="department-text">{dept}</span>
                </div>
              </td>
              <td>{row.manager_name || 'Unknown'}</td>
              <td>
                <ApprovalStatusBadge status={row.approval_status} size="small" />
              </td>
              <td>{formatDate(row.requested_at)}</td>
              <td className="center">
                {row.resubmission_count > 0 ? (
                  <span className="approval-resubmission-badge">{row.resubmission_count}</span>
                ) : (
                  '0'
                )}
              </td>
              <td className="admin-approvals-action-cell">
                {onViewDevice && (
                  <div className="action-buttons">
                    <button
                      type="button"
                      className={`btn-action ${isPending ? 'btn-edit' : 'btn-view'}`}
                      onClick={() => onViewDevice(row)}
                      title={isPending ? 'Review device and make decision' : 'View device details'}
                    >
                      {isPending ? 'Review' : 'View'}
                    </button>
                  </div>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default AdminApprovalsTable;
